module.exports = __webpack_public_path__ + "img/-LV4ql6acqlgkaCf1FD0.d3356fd7.jpg";